if (process.env.NODE_ENV !== '"development"') {
  module.exports = require('./configStore.prod'); // eslint-disable-line global-require
} else {
  module.exports = require('./configStore.dev'); // eslint-disable-line global-require
}
